import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Panel } from 'src/components/app-ui'
import Certification from 'src/pages/collection/components/collection-page-view/components/collection-settings/components/certification'

const useStyles = makeStyles({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '24px 28px',
  },
})

/** The certification component draws its own switch and title. */
const CertificationTab = () => {
  const classes = useStyles()

  return (
    <Panel className={classes.root}>
      <Certification />
    </Panel>
  )
}

export default CertificationTab
